module.exports = __webpack_public_path__ + "img/k01.5f5f6b46.png";